var exports = {
  "Q": "x31de4314--ed444c--text",
};

module.exports = exports;
